import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "ALGORITHMIC SUPPRESSION",
  "SHADOW-RANKING",
  "DATA-BROKER EXPOSURE",
  "BEHAVIORAL TARGETING",
  "REPUTATION MANIPULATION",
  "PRICING DISCRIMINATION",
  "SEARCH DEMOTION",
  "FEED THROTTLING",
  "PREDATORY SCORING",
];

export default function TickerBar() {
  return (
    <div
      data-testid="ticker-bar"
      className="border-b border-white/10 bg-black py-3 marquee-fade"
    >
      <Marquee gradient={false} speed={42} pauseOnHover>
        <div className="flex items-center gap-12 pr-12 font-mono text-[11px] uppercase tracking-[0.28em] text-gray-400">
          {ITEMS.concat(ITEMS).map((t, i) => (
            <span key={i} className="inline-flex items-center gap-3">
              <span className="inline-block h-1 w-1 bg-red-500" />
              {t}
            </span>
          ))}
        </div>
      </Marquee>
    </div>
  );
}
